export function getColorByEstado(estado) {
  switch (estado) {
    case 1: // "PENDIENTE"
      return "#940E0A";
    case 2: // "EN GESTION"
      return "#CA13B1";
    case 3: // "faKey"
      return "#A4338A";
    case 4: // "faCopy"
      return "#01A291";
    case 8: // "Pre Ingreso"
      return "#4979FC";
    case 5: // "RESUELTO"
      return "#2FEB8D";
    case 6: // "ABIERTA"
      return "#00ABE3";
    default:
      return "#CCCCCC";
  }
}
